import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import PropTypes from 'prop-types';
import { USER_GET_OAUTH_INFO } from './queries';
import { USER_OAUTH_REVOKE } from './mutations';
import { showAlert } from '../../utilities/notifications';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import { Typography } from '../../components';

const OauthRevokeModal = ({ setOpen }) => {
  const { t: translate } = useTranslation();

  const { mutateAsync: revokeOauth, isLoading: revokeOauthLoading } =
    useMutation(USER_OAUTH_REVOKE);

  const { refetch: refetchOauthInfo } = useQuery(USER_GET_OAUTH_INFO);

  const handleRevokeOauth = async () => {
    try {
      if (revokeOauthLoading) return;
      await revokeOauth();
      refetchOauthInfo();
      showAlert({
        message: translate('oauth_revoke_modal_disconnect_notificaiton'),
        type: 'success',
      });
      setOpen(false);
    } catch (error) {
      let errorMessage =
        (error?.response?.data?.message ||
          (typeof error?.response?.data === 'string' && error?.response?.data) ||
          error?.message) ??
        'Oops, something went wrong! Please try again.';
      if (errorMessage.includes('of undefined')) {
        errorMessage = `Oops, something went wrong! Please try again.`;
      }

      showAlert({ message: errorMessage, type: 'danger' });
    }
  };

  return (
    <ModalBodyLayout
      title={translate('oauth_revoke_modal_title')}
      withBack={false}
      renderFooter={() => (
        <button
          type="button"
          className="btn btn-primary w-100 text-bold"
          loading={revokeOauthLoading}
          onClick={() => {
            handleRevokeOauth();
          }}>
          {translate('oauth_revoke_modal_disconnect')}
        </button>
      )}>
      <div className="d-flex flex-column justify-content-center pb-4">
        <Typography as="h6" variant="baseSemi">
          {translate('oauth_revoke_modal_subtitle')}
        </Typography>
      </div>
      <Typography as="p" variant="base">
        {translate('oauth_revoke_modal_extra_1')}
      </Typography>
      <Typography variant="body2">{translate('oauth_revoke_modal_extra_2')}</Typography>
      <ul className="m-0 pt-4 d-flex flex-column gap-2">
        <li>
          <Typography as="p" variant="base">
            {translate('oauth_revoke_modal_note1')}
          </Typography>
        </li>
        <li>
          <Typography as="p" variant="base">
            {translate('oauth_revoke_modal_note2')}
          </Typography>
        </li>
        <li>
          <Typography as="p" variant="base">
            {translate('oauth_revoke_modal_note3')}
          </Typography>
        </li>
      </ul>
    </ModalBodyLayout>
  );
};

OauthRevokeModal.propTypes = {
  setOpen: PropTypes.func.isRequired,
};

export default OauthRevokeModal;
